import React, { Component } from 'react';
import Select from 'react-select';
import { injectIntl, intlShape } from 'react-intl';
import { array, func, bool, string, node } from 'prop-types';
import { Button, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

class StatisticsFilter extends Component {
  static propTypes = {
    options: array.isRequired,
    onFilterChange: func.isRequired,
    onFilterApply: func.isRequired,
    onFilterChange: func.isRequired,
    id: string.isRequired,
    label: node.isRequired,
    name: string.isRequired,
    multiple: bool,
    placement: string,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    options: [],
    onFilterChange() {},
    onFilterApply() {},
    onFilterChange() {},
    multiple: false,
    placement: 'bottom',
    label: 'Button label',
  };

  state = {
    open: false,
    label: '',
    isLoaded: false,
  };

  componentDidMount() {
    this.updateLabel();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.value && prevProps.value !== this.props.value) {
      this.updateLabel();
    }

    // загружаем фильтры один раз после открытия
    const { loadOptions, deferLoad } = this.props;
    const { isLoaded, open } = this.state;
    if (deferLoad && !isLoaded && open && open !== prevState.open) {
      loadOptions().then(() => {
        this.setState(() => ({
          isLoaded: true,
        }));
      });
    }
  }

  toggle = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  applyFiltersHandler = () => {
    this.setState(() => ({ open: false }));
    this.props.onFilterApply();
    this.updateLabel();
  };

  clearFiltersHandler = name => {
    this.props.onFilterClear(name, this.updateLabel);
    this.setState(() => ({ open: false }));
  };

  updateLabel = () => {
    this.setState(() => ({ label: this.props.getLabel() }));
  };

  renderSelectPlaceholder = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'main.select',
      defaultMessage: 'Select...',
    });
  };

  renderSelectNoResultsText = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'statistics.filters.no-results-text',
      defaultMessage: 'No filters found',
    });
  };

  filterChangeHandler = e => {
    this.props.onFilterChange(e);
    this.updateLabel();
  };

  render() {
    const { options, value, multiple, id, placement } = this.props;

    const { open, label } = this.state;

    return (
      <Dropdown isOpen={open} toggle={this.toggle} tag="span">
        <DropdownToggle
          onClick={this.toggle}
          data-toggle="dropdown"
          aria-expanded={open}
          tag="span"
        >
          <Button
            size="sm"
            color="light"
            active={open}
            id={id}
            onClick={this.toggle}
            outline
            className="statistics-filter-button btn-toggler"
          >
            {label}
            <i className="dropdown-toggle" />
            <span className="arrow" />
          </Button>
        </DropdownToggle>
        <DropdownMenu placement={placement} className="filter-popover">
          <Select
            options={options}
            onChange={this.filterChangeHandler}
            multi={multiple}
            value={value}
            placeholder={this.renderSelectPlaceholder()}
            noResultsText={this.renderSelectNoResultsText()}
            closeOnSelect={false}
            arrowRenderer={null}
            clearable={false}
            openOnFocus
            autoFocus
            alwaysOpened
          />
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default injectIntl(StatisticsFilter);
